function isWalkToEarnPath(pathname: string): boolean {
    return pathname === '/walktoearn' || pathname.startsWith('/walktoearn/');
}

function isSocialWalkingPath(pathname: string): boolean {
    return pathname === '/socialwalking' || pathname.startsWith('/socialwalking/');
}

export function getFunnelSource(): string {
    const hostname = window.location.hostname;
    const pathname = window.location.pathname;

    // Walktoearn prize-first fork — path only (never hostname language).
    if (isWalkToEarnPath(pathname)) {
        return 'walktoearn';
    }

    // Social Walking — 30-Day Walk Together Challenge fork.
    if (isSocialWalkingPath(pathname)) {
        return 'socialwalking';
    }

    // Detect Spanish from URL only — never from
    // browser language. Spanish funnels use either:
    // - a subdomain containing '-es'
    // - a pathname starting with '/es'
    const isEs =
        hostname.includes('-es.') ||
        hostname.startsWith('es.') ||
        pathname.startsWith('/es/') ||
        pathname === '/es';

    if (
        hostname.includes('walkmore') ||
        hostname.includes('move-club')
    ) {
        return isEs ? 'walkmore-es' : 'walkmore';
    }

    return isEs ? 'aaron-es' : 'aaron';
}

export function getFunnelLocale(): 'en' | 'es' {
    const hostname = window.location.hostname;
    const pathname = window.location.pathname;

    const isEs =
        hostname.includes('-es.') ||
        hostname.startsWith('es.') ||
        pathname.startsWith('/es/') ||
        pathname === '/es';

    return isEs ? 'es' : 'en';
}

/**
 * Fire-and-forget Loops event sender.
 * Does NOT await — never blocks the funnel flow.
 *
 * props → flat object with email + any contact/event fields
 *         (all top-level keys are written to the Loops contact record)
 */
export function fireLoopsEvent(
    eventName: string,
    props: Record<string, any>
) {
    fetch('/api/loops-event', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            eventName,
            ...props,
        }),
    }).catch(() => { /* fire and forget */ });
}
